/** Ключ конфига, куда `@cian/experiments` кладёт группы пользователя после `getExperiments`. */
export const EXPERIMENTS_CONFIG_KEY = 'experiments.ab.experiments';

/** Группы пользователя по имени эксперимента. `null` приходит, когда AB не отнёс его ни в одну. */
export type TExperimentGroups = Record<string, string | null | undefined>;

/**
 * Группа пользователя в эксперименте — без побочных эффектов.
 *
 * В отличие от хука `use()` из `@cian/experiments` не отправляет экспозицию: она нужна там,
 * где фича показывается, а не там, где по группе просто ветвится поведение.
 */
export function getExperimentGroup(groups: TExperimentGroups | null | undefined, name: string): string | null {
  return groups?.[name] ?? null;
}
